import React from "react";
import qrcode from "qrcode-generator";

// A QR code for a link the Owner hands to someone standing next to them: a
// staff access link or an invitation (issue #32). What it carries is a
// credential, so it is drawn here from the encoder's module grid and never
// fetched from a QR service; the value is in the pattern and nowhere in the
// markup — no text, no title, no attribute. The encoder's own SVG helper would
// add a title, which is why it is not used.
//
// Error correction M, auto-sized, with the four-module quiet zone scanners need.

const QUIET = 4;

export function QrCode({ value, label, size = 208 }) {
  const drawing = React.useMemo(() => {
    const code = qrcode(0, "M");
    code.addData(value, "Byte");
    code.make();
    const count = code.getModuleCount();
    let d = "";
    for (let row = 0; row < count; row += 1) {
      for (let col = 0; col < count; col += 1) {
        if (code.isDark(row, col)) d += `M${col + QUIET} ${row + QUIET}h1v1h-1z`;
      }
    }
    return { d, extent: count + 2 * QUIET };
  }, [value]);
  return <svg className="qr-code" role="img" aria-label={label} width={size} height={size}
    viewBox={`0 0 ${drawing.extent} ${drawing.extent}`} shapeRendering="crispEdges">
    <rect width={drawing.extent} height={drawing.extent} fill="#fff"/>
    <path d={drawing.d} fill="#000"/>
  </svg>;
}
